<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('employeesSalaries.salaryAddition')"
          :description="$t('employeesSalaries.FromHereYouCanAddNewEmployeesSalaries')"
        />
        <indexTable
          :searchText="$t('employeesSalaries.SearchForASalary')"
          :emptyTableText="$t('employeesSalaries.ThereAreNoPaychecks')"
          :emptyTableSubText="$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain')"
          :buttonRole="$checkRole('employees_salaries_add')"
          :statusSearch="true"
          :statusValues="[
            { title: $t('orders.situation'), value: '' },
            { title: $t('orders.all'), value: '' },
            { title: $t('invoices.draft'), value: 0 },
            { title: $t('invoices.approved'), value: 1 }
          ]"
          :cloumns="[
            {
              column: 'code',
              title: $t('employeesSalaries.Salary'),
              type: 'mainLink',
              sort: true
            },
            {
              column: 'employee_id',
              title: $t('employeesSalaries.functionary'),
              type: 'link',
              to: 'employee',
              sort: true,
              link: true
            },
            {
              column: 'date',
              title: $t('employeesSalaries.date'),
              type: 'text',
              sort: true
            },
            {
              column: 'description',
              title: $t('employeesSalaries.thatsAbout'),
              type: 'text',
              sort: true
            },
            {
              column: 'notes',
              title: $t('employeesSalaries.note'),
              type: 'text',
              sort: true
            },
            {
              column: 'cost',
              title: $t('employeesSalaries.cost'),
              type: 'text',
              sort: true
            },
            {
              column: 'user_name',
              title: 'اسم المسئول',
              type: 'text',
              sort: true
            },
            {
              column: 'status',
              title: $t('bills.situation'),
              type: 'status',
              sort: true,
              values: [
                { title: $t('invoices.draft'), value: 0, color: 'dark' },
                { title: $t('invoices.approved'), value: 1, color: 'success' }
              ]
            },
            {
              column: 'options',
              title: $t('employeesSalaries.Settings'),
              type: 'options',
              options: [
                { name: 'show' },
                { name: 'printEmployeesSalarie', role: true },
                {
                  name: 'edit',
                  role: $checkRole('employees_salaries_edit')
                },
                { name: 'file' },
                { name: 'download', role: true },
                {
                  name: 'delete',
                  role: $checkRole('employees_salaries_delete')
                }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('allerts.Attention'),
            areYouReallySureToDeleteTheItem: $t('allerts.areYouReallySureToDeleteTheItem'),
            close: $t('allerts.close'),
            confirm: $t('allerts.confirm'),
            loading: $t('allerts.loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'

export default {
  data() {
    return {
      path: '/employeesSalaries'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
